import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icon-male.png'
import _imports_1 from '@/assets/icon-female.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "head flex flex-ai-c" }
const _hoisted_3 = { class: "fs-16 bold flex flex-ai-c" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "icon-gender"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "icon-gender"
}
const _hoisted_6 = { class: "body mg-t-20 flex gap-16" }
const _hoisted_7 = { class: "flex gap-100 bg-blue" }
const _hoisted_8 = { class: "flex-item flex-1 flex flex-column flex-jc-sb" }
const _hoisted_9 = { class: "value fs-22 bold mg-t-10" }
const _hoisted_10 = { class: "flex-item flex-1 flex flex-column flex-jc-sb" }
const _hoisted_11 = { class: "value fs-22 bold mg-t-10" }
const _hoisted_12 = { class: "bg-blue flex-1 flex flex-column flex-jc-c" }
const _hoisted_13 = { class: "fc-black" }
const _hoisted_14 = { class: "mg-t-10" }
const _hoisted_15 = { class: "fc-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.infoData.userName), 1),
            (_ctx.infoData.sex === 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.infoData.sex === 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "name fc-lightgray" }, "当前共发薪", -1)),
              _createElementVNode("div", _hoisted_9, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fs-14" }, "¥", -1)),
                _createTextVNode(_toDisplayString(_ctx.infoData.totalPayAmount), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "name fc-lightgray" }, "当前共预支", -1)),
              _createElementVNode("div", _hoisted_11, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "fs-14" }, "¥", -1)),
                _createTextVNode(_toDisplayString(_ctx.infoData.totalAdvanceAmount), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fc-lightgray" }, "电话号码：", -1)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.infoData.phone), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fc-lightgray" }, "身份证号：", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.infoData.idCardNo), 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}